function OpenStatus() {
  return (
    <div className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[16px] bg-[#FEF9C3] font-OpenSansSemiBold font-[600] text-[#A16207] text-[14px] leading-[20px] tracking-[0.14px] capitalize [mix-blend-mode:multiply]">
      Open
    </div>
  );
}

export default OpenStatus;
